import React from "react";
import "./solution.css";
import solutionImage1 from "../../assets/SolutionSection/Application Navigation.svg";
import solutionImage2 from "../../assets/SolutionSection/Automated Software Testing.svg";
import solutionImage3 from "../../assets/SolutionSection/Customer Support Automation.svg";
import solutionImage4 from "../../assets/SolutionSection/Business Process Automation.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";

export default function Solution() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const points = [
    {
      heading: "Enterprise Application Navigation",
      paragraph:
        "Automate interactions in SAP, CRM, and ERP systems to improve efficiency and reduce manual effort.",
      img: solutionImage1,
    },
    {
      heading: "Automated Software Testing",
      paragraph:
        "Validate UI functionality without the need for scripts, ensuring smooth and error-free user experiences.",
      img: solutionImage2,
    },

    {
      heading: "Business Process Automation",
      paragraph:
        "Streamline repetitive UI tasks with AI-driven workflows to enhance productivity and reduce costs.",
      img: solutionImage4,
    },
    {
      heading: "Customer Support Automation",
      paragraph:
        "Process form submissions and respond to queries instantly with AI-driven automation.",
      img: solutionImage3,
    },
  ];

  return (
    <section
      className={`solution-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="two"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Solution</span>
          </div>
          <div className="heading-description">
            <h2>Eliminate Manual Clicks, Accelerate Workflows</h2>
            <p>
              AI Aviator automates GUI tasks with precision, reducing errors and
              boosting efficiency across applications.
            </p>
          </div>
        </div>
        <div className="section-wrapper row">
          <div className="col-12 col-sm-6 col-md-7">
            <div className="solutions-cards-inner">
              <img src={points[0].img} alt="solution-card" />
              <div className="solution-card-text">
                <h3>{points[0].heading}</h3>
                <p>{points[0].paragraph}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-5">
            <div className="solutions-cards-inner">
              <img src={points[1].img} alt="solution-card" />
              <div className="solution-card-text">
                <h3>{points[1].heading}</h3>
                <p>{points[1].paragraph}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-5">
            <div className="solutions-cards-inner">
              <img src={points[2].img} alt="solution-card" />
              <div className="solution-card-text">
                <h3>{points[2].heading}</h3>
                <p>{points[2].paragraph}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-7">
            <div className="solutions-cards-inner">
              <img src={points[3].img} alt="solution-card" />
              <div className="solution-card-text">
                <h3>{points[3].heading}</h3>
                <p>{points[3].paragraph}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
